<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content">
    <div class="header">
      <i
        *ngIf="canDownload"
        (click)="download()"
        style="cursor: pointer; margin-right: 1rem"
        class="las la-download font-25"
      ></i>
      <span style="cursor: pointer; font-size: 1.3rem" (click)="cancel()"
        >x</span
      >
    </div>
    <div class="modal-body">
      <div class="add-contact-box">
        <div class="add-contact-content">
          <span
            style="color: #2f44b2; word-wrap: break-word"
            class="text-center"
            >{{ message | cutString : maxLength }}</span
          >
        </div>
      </div>
    </div>
  </div>
</div>
